import SeoLandingPage from "@/components/SeoLandingPage";

const InteriorDemolition = () => (
  <SeoLandingPage
    slug="interior-demolition-wisconsin"
    metaTitle="Interior Demolition | Green Bay & De Pere"
    metaDescription="Expert interior demolition in Northeast Wisconsin for kitchens, bathrooms, flooring, walls, and remodels. Careful tear-out, debris removal, and free estimates."
    h1="Interior Demolition in Northeast Wisconsin"
    heroImage="/images/chimney.jpg"
    heroIntro="Start your renovation with a clean, carefully prepared space. We handle selective interior tear-outs, protect the surrounding property, and remove every load of debris."
    serviceName="Interior Demolition"
    bullets={[
      "Kitchen cabinet, countertop, backsplash, and fixture removal.",
      "Bathroom vanity, tub, shower, tile, and non-structural tear-out.",
      "Carpet, hardwood, laminate, vinyl, and tile flooring removal.",
      "Drywall, ceiling, insulation, and non-load-bearing wall removal.",
      "Dust-conscious work-area containment and protection for surfaces that remain.",
      "Complete demolition debris hauling and a broom-clean finish for the next trade.",
    ]}
    whyUs={[
      "One experienced crew handles both demolition and debris removal, so your project stays organized.",
      "Service for homeowners, contractors, investors, and property managers.",
      "Selective demolition protects the parts of your property that are staying in place.",
      "Clear written scope and pricing before work begins, with photo estimates available.",
    ]}
    processSteps={[
      { title: "Show us the project", detail: "Upload photos or schedule a walkthrough so we can identify what comes out and what must remain protected." },
      { title: "Confirm the scope", detail: "You receive a clear estimate covering labor, tear-out, loading, disposal, and the expected schedule." },
      { title: "Protect and demolish", detail: "We isolate the work area, remove the selected materials carefully, and keep the job site controlled." },
      { title: "Haul and hand off", detail: "Debris is removed and the area is left broom-clean and ready for your contractor or next renovation step." },
    ]}
    faqs={[
      { q: "What types of interior demolition do you handle?", a: "We handle selective residential and light-commercial tear-outs, including kitchens, bathrooms, flooring, drywall, ceilings, insulation, cabinetry, fixtures, and non-load-bearing walls." },
      { q: "Do you remove all demolition debris?", a: "Yes. Loading, hauling, and responsible disposal are included in the written scope, and we leave the work area broom-clean for the next phase." },
      { q: "Can you work with my remodeling contractor?", a: "Yes. We coordinate the demolition scope and schedule with homeowners and contractors so the space is ready when the next trade arrives." },
      { q: "How much does interior demolition cost in Northeast Wisconsin?", a: "Cost depends on the materials, access, disposal weight, and size of the tear-out. Upload photos for a free written estimate based on your specific project." },
      { q: "Do you remove load-bearing walls?", a: "Structural changes require proper engineering and permits. We can review the project with you and limit our work to the approved demolition scope." },
    ]}
    ctaHeadline="Ready to start your renovation?"
  />
);

export default InteriorDemolition;
